/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import IconInfo from 'components/icons/IconInfoNew';
import IconTick from 'components/icons/iconTick';
import CtaButton from 'components/essentials/Cta/CtaButton';
import FlyoutContainer from 'components/consumer/FlyoutContainer';
import { colorGrayLight1 } from 'styles/layout/colors';
import useScreen from 'hooks/useScreen';
import PDPPriceSection from '../PDPPriceSection';

const PDPExtraOptionSelectorUI = ({
  loading,
  isAdded,
  priceObj,
  onAdd,
  onRemove,
}) => {
  // hooks
  const { isDesktop } = useScreen();

  // state
  const [flyOutTop, setFlyOutTop] = useState(0);
  const [isFlyOutVisible, setIsFlyOutVisible] = useState(false);

  // refs
  const containerRef = useRef(null);

  // functions
  const toggleFlyOut = isVisible => {
    if (isDesktop) {
      setIsFlyOutVisible(isVisible);
      setFlyOutTop(containerRef.current?.getBoundingClientRect().top || 0);
    }
  };

  return (
    <div className="mt-8 mx-0 mb-0 lg:z-[2] lg:relative" ref={containerRef}>
      {isFlyOutVisible && (
        <FlyoutContainer
          top={flyOutTop}
          headerBgColor="grey"
          mobileContentNoPadding
          title="How the extra cushion works"
          imageUrl="https://joybird2.imgix.net/public_img/extra-cushion.png"
          onClose={() => setIsFlyOutVisible(false)}
          isOpen={isFlyOutVisible}
          content={
            <>
              <div className="text-xs">
                Remove the ottoman and replace your chaise cushion with your
                extra cushion to instantly turn your sectional into a sofa!{' '}
              </div>
              <br />
              <div className="text-xs">
                Do the opposite and, you guessed it, you’ve got a sectional.
              </div>
            </>
          }
        />
      )}
      <div className="text-gray text-base font-bold">
        <span>Add Extra Cushion (Optional)</span>
        <button
          type="button"
          className="relative cursor-pointer p-2 [background:none] border-0"
          onMouseEnter={() => toggleFlyOut(true)}
          onMouseLeave={() => toggleFlyOut(false)}
          onClick={() => setIsFlyOutVisible(true)}
        >
          <IconInfo height={14} width={14} color={colorGrayLight1} />
        </button>
      </div>
      <div className="flex mt-2 border border-solid border-gray-light6 rounded">
        <div
          className="flex-[0.43] cursor-pointer bg-white lg:flex-[0.4] [&_img]:h-full [&_img]:object-contain"
          onMouseOver={() => toggleFlyOut(true)}
          onMouseOut={() => toggleFlyOut(false)}
        >
          <JBImage
            width={200}
            src="https://joybird2.imgix.net/public_img/extra-cushion.png"
          />
        </div>

        <div className="p-4 flex-[0.57] lg:flex-[0.6]">
          <div className="text-sm font-bold">Extra Cushion</div>
          <div>
            <PDPPriceSection
              priceObj={priceObj}
              variant="PDPExtraOptionSelector"
            />
          </div>
          <div className="text-xs mt-2 mx-0 mb-3 text-gray-light1">
            Get an extra cushion to switch between sectional and sofa.
          </div>
          <CtaButton
            block
            type="submit"
            color={isAdded ? 'brand' : 'brand-light'}
            styling="solid-button"
            data-xc="add-upsell-button"
            className="w-auto min-w-[80px] p-[.3rem] md:px-3 md:py-[.3rem] hover:bg-brand-light"
            disabled={loading}
            onClick={isAdded ? onRemove : onAdd}
            isLoading={loading}
          >
            {isAdded ? (
              <span className="items-center flex">
                <IconTick height="16" width="16" />
                <span>Added</span>
              </span>
            ) : (
              '+ Add'
            )}
          </CtaButton>
        </div>
      </div>
    </div>
  );
};

PDPExtraOptionSelectorUI.propTypes = {
  loading: PropTypes.bool,
  isAdded: PropTypes.bool,
  priceObj: PropTypes.object,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
};

export default PDPExtraOptionSelectorUI;
